export default __webpack_public_path__ + "static/media/Jntuk-logo.1f1c4cd1.png";